import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { autoCompleteSearch } from '../api/store';
import './GlobalSearchModal.css';

const GlobalSearchModal = ({onClose}) => {


    const navigate = useNavigate();
    const [searchKeyword, setSearchKeyword] = useState('');
    const [ACKList, setACKList] = useState([]);
    const [recentKeyword, setRecentKeyword] = useState([]);


    const handleInput = (e) => {
        setSearchKeyword(e.target.value);
    }

    const handleSearch = (keyword) => {
        onClose();
        handleAddRecentKeyword(keyword);
        console.log(encodeURIComponent(keyword.trim()));
        navigate(`/search?type=store&keyword=${encodeURIComponent(keyword.trim())}`);
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && searchKeyword.trim()) {
            handleSearch(searchKeyword);
        }
      };

    const highlightMatch = (text, keyword) => {
        if (!keyword) return text;
        const escaped = keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const regex = new RegExp(`(${escaped})`, 'gi');
        const parts = text.split(regex);
        return parts.map((part, i) =>
          regex.test(part)
            ? <span key={i} style={{ color: 'red' }}>{part}</span>
            : <span key={i}>{part}</span>
        )
      };

      const handleAddRecentKeyword = (keyword) => {
        if (recentKeyword.includes(keyword)) {
            return;
        }
        const newRecentKeyword = [keyword, ...recentKeyword];
        localStorage.setItem('recentSearchKeyword', JSON.stringify(newRecentKeyword));
        setRecentKeyword(newRecentKeyword);
      }

      const handleDeleteRecentKeyword = (keyword) => {
        const newRecentKeyword = recentKeyword.filter((item)=>item !== keyword);
        localStorage.setItem('recentSearchKeyword', JSON.stringify(newRecentKeyword));
        setRecentKeyword(newRecentKeyword);
      }
    

    //입력한 검색어가 2글자 이상일때는 검색어 자동완성 제공
    useEffect(()=>{
        const trimmedKeyword = searchKeyword.trim();
        if(trimmedKeyword.length >= 2){
            const timeout = setTimeout(()=>{
                autoCompleteSearch(trimmedKeyword)
                .then(({data, error})=>{
                    if(!error){
                        setACKList(data);
                    }
                })
            }, 200);
            return () => clearTimeout(timeout);
        }

        else {
            setACKList([]);
        }
    }, [searchKeyword])

    //최근 검색어 리스트
    useEffect(()=>{
        const stored = localStorage.getItem('recentSearchKeyword');
        if(stored){
            setRecentKeyword(JSON.parse(stored));
        }
    }, [])
        

  return (
    <div className="modal search-global" data-position="top">
        <div className="modal-container">
            <div className="modal-header">
                
                <button onClick={onClose} className="modal-close">
                    <img src="/back.svg" alt="Close Modal" />
                </button>
                <div className="search-input-wrap">
                    <input className="search-input" 
                        type="text" 
                        placeholder="검색어를 입력하세요" 
                        onChange={handleInput}
                        onKeyDown={handleKeyDown}
                        autoFocus
                        />

                    {/* 검색 돋보기 버튼 */}
                    <button onClick={()=>handleSearch()} className="search-icon">
                        <img src="/magnifying_glass.svg" alt="검색" />
                    </button>
                </div>

                
            </div>

            <div className="modal-body">

                {ACKList.length > 0 && (
                    <div className="autocomplete-list">
                        <ul>
                            {ACKList.map((item)=>(
                                <li key={item.goods_seq} className="autocomplete-keyword">
                                    <div className="product-item" onClick={()=>handleSearch(item.display_goods_name)}>
                                        {highlightMatch(item.display_goods_name, searchKeyword)}
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
                {searchKeyword.length > 0 && ACKList.length === 0 && (
                    <div className="autocomplete-list">
                        <div className="no-search">결과가 없습니다.</div>
                    </div>
                )}

               
                <section className="recent-keyword">
                    <h3>최근 검색어</h3>
                    <ul>
                        {recentKeyword.map((keyword)=>{
                            return (
                            <li>
                                <div className="keyword">
                                    <span style={{cursor: 'pointer'}} onClick={()=>handleSearch(keyword)}>{keyword}</span>
                                    <button className="delete-keyword" onClick={()=>handleDeleteRecentKeyword(keyword)}>
                                        <img src="/close.svg" alt="삭제" />
                                    </button>
                                </div>
                            </li>
                            )
                        })}
                    </ul>
                </section>
                <section className="frequently-used-keyword">
                    <h3>인기 검색어</h3>
                    <ol>
                        <li><button type="button" onClick={()=>{handleSearch('코카-콜라')}}>코카-콜라</button></li>
                        <li><button type="button" onClick={()=>{handleSearch('코카-콜라 제로')}}>코카-콜라 제로</button></li>
                        <li><button type="button" onClick={()=>{handleSearch('닥터페퍼')}}>닥터페퍼</button></li>
                        <li><button type="button" onClick={()=>{handleSearch('스프라이트')}}>스프라이트</button></li>
                        <li><button type="button" onClick={()=>{handleSearch('파워에이드')}}>파워에이드</button></li>
                        <li><button type="button" onClick={()=>{handleSearch('마테차')}}>마테차</button></li>
                        <li><button type="button" onClick={()=>{handleSearch('체리')}}>체리</button></li>
                        <li><button type="button" onClick={()=>{handleSearch('조지아')}}>조지아</button></li>
                        <li><button type="button" onClick={()=>{handleSearch('콜라')}}>콜라</button></li>
                        <li><button type="button" onClick={()=>{handleSearch('골프 세트')}}>골프 세트</button></li>
                    </ol>
                </section>
            </div>
        </div>
    </div>
  );
};

export default GlobalSearchModal;